import { getValue } from "../../common-utilities/utils";
import { HOSTNAME, REST_URLS } from "./endpoints";
import { HTTP_METHODS, invokeApi } from "./http-service";

export const getSelectVendorList = async (intranetTokenKey, label, value) => {
  let vendorList = [];
  const labelKey = label ? label : "label";
  const valueKey = value ? value : "value";
  try {
    const results = await invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.VENDOR_LIST}`,
      null,
      null,
      null,
      intranetTokenKey
    );

    vendorList =
      results?.map?.((item) => {
        return {
          [valueKey]: item.id,
          [labelKey]: getValue(item.name, true),
          ...item,
        };
      }) || [];
  } catch (err) {
    console.log("Error occcurred while getting Vendor list", err);
  }
  return vendorList;
};
